import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import config from "../../Config";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import EmployeeDropDown from "../Shared/EmployeeDropDown";
import TimeTableMenu from "./TimeTableMenu";
import { scrollToTop } from "../Shared/ScrollOnTop";

function TimeTableTeacherWise() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(parseInt(localStorage.getItem("ID"), 10) || 0);
  const [MemberType] = useState(localStorage.getItem("MemberType") || "Admin");
  const today = new Date();

  const [SessionId, setSessionId] = useState(localStorage.getItem("DefaultSession") || "0");
  const [WingId, setWingId] = useState(0);
  const [ClassId, setClassId] = useState(0);
  const [SectionId, setSectionId] = useState(0);
  const [TeacherId, setTeacherId] = useState(0);
  const [ReportMonth, setReportMonth] = useState(today.getMonth() + 1);
  const [ReportYear, setReportYear] = useState(today.getFullYear());
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadReport = () => {
    if (!(parseInt(SessionId, 10) > 0)) {
      toast.error("Select session.");
      return;
    }
    setLoading(true);
    axios
      .post(config.base_url + "TimeTable/GetTeacherWiseMonthlyLoad", {
        AccessKey,
        UserID,
        MemberType,
        SessionID: parseInt(SessionId, 10),
        SchoolID: 1,
        Wing_Id: parseInt(WingId, 10) || 0,
        Class_Id: parseInt(ClassId, 10) || 0,
        Section_Id: parseInt(SectionId, 10) || 0,
        Teacher_ID: parseInt(TeacherId, 10) || 0,
        ReportMonth: parseInt(ReportMonth, 10) || 0,
        ReportYear: parseInt(ReportYear, 10) || 0,
      })
      .then((res) => {
        if (res.data.status_code === 1) setRows(res.data.ListofRecords || []);
        else {
          setRows([]);
          toast.error(res.data.status_message || "Failed.");
        }
      })
      .catch(() => toast.error("Network error."))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <TimeTableMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><NavLink to="/Dashboard" onClick={scrollToTop}>Dashboard</NavLink></li>
                    <li className="breadcrumb-item active">Teacher-wise Timetable</li>
                  </ol>
                </nav>
                <div className="page-title">Teacher-wise Monthly Teaching Load</div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content mt-3">
          <div className="container">
            <div className="card mb-3">
              <div className="card-body">
                <div className="row g-2">
                  <div className="col-md-2">
                    <label className="form-label">Session</label>
                    <select className="form-select" value={SessionId} onChange={(e) => setSessionId(e.target.value)}>
                      <option value="0">Select</option>
                      <SessionsDropDown selectedSession={parseInt(SessionId, 10) || 0} />
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Wing</label>
                    <select className="form-select" value={WingId} onChange={(e) => { setWingId(parseInt(e.target.value, 10) || 0); setClassId(0); setSectionId(0); }}>
                      <option value="0">All</option>
                      <WingsDropDown selectedWingId={WingId} />
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Class</label>
                    <select className="form-select" value={ClassId} onChange={(e) => { setClassId(parseInt(e.target.value, 10) || 0); setSectionId(0); }}>
                      <option value="0">All</option>
                      <ClassesDropDown WingID={WingId} SessionID={parseInt(SessionId, 10) || 0} selectedClassId={ClassId} />
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Section</label>
                    <select className="form-select" value={SectionId} onChange={(e) => setSectionId(parseInt(e.target.value, 10) || 0)}>
                      <option value="0">All</option>
                      <SectionDropDown ClassID={ClassId} selectedSectionId={SectionId} />
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">Teacher</label>
                    <select className="form-select" value={TeacherId} onChange={(e) => setTeacherId(parseInt(e.target.value, 10) || 0)}>
                      <option value="0">All</option>
                      <EmployeeDropDown selected={TeacherId} />
                    </select>
                  </div>
                  <div className="col-md-1">
                    <label className="form-label">Month</label>
                    <input type="number" min="1" max="12" className="form-control" value={ReportMonth} onChange={(e) => setReportMonth(e.target.value)} />
                  </div>
                  <div className="col-md-1">
                    <label className="form-label">Year</label>
                    <input type="number" min="2000" max="2100" className="form-control" value={ReportYear} onChange={(e) => setReportYear(e.target.value)} />
                  </div>
                  <div className="col-md-2 d-flex align-items-end">
                    <button className="button button-primary w-100" onClick={loadReport}>Load</button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-theme table-sm">
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        <th>Teacher</th>
                        <th>Total Periods (Month)</th>
                        <th>Total Minutes</th>
                        <th>Total Hours</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading && rows.length === 0 ? <tr><td colSpan="5" className="text-muted">No records.</td></tr> : null}
                      {rows.map((r, index) => (
                        <tr key={r.Teacher_ID}>
                          <td>{index + 1}</td>
                          <td>{r.Teacher_Name || `Teacher #${r.Teacher_ID}`}</td>
                          <td>{r.TotalPeriods}</td>
                          <td>{r.TotalMinutes}</td>
                          <td>{r.TotalHours}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TimeTableTeacherWise;
